// Restored from production OTA 2026-08-21 (module 1412).
import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = (token, data) => {
    const { config } = firebase;
    const settings = store.getState().settingsdata.settings;
    // On the web admin, call the hosting origin it is served from; everywhere
    // else (the apps) use the project's default hosting domain.
    const host =
        typeof window !== 'undefined' && window.location && settings && settings.CompanyWebsite === window.location.origin
            ? window.location.origin
            : `https://${config.projectId}.web.app`;

    fetch(`${host}/send_notification`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            token: token,
            ...data
        })
    })
    .then(() => {})
    .catch((error) => {
        console.log(error);
    });
};
